// Car information display component.
import React from 'react';
import styles from '../css/ticketEntry.module.css';
import { FaCar } from 'react-icons/fa';
import { IoIosColorFill } from 'react-icons/io';

export default function CarInfo({
  make,
  freqMake,
  setFreqMake,
  setMake,
  color,
  setColor,
  license,
  setLicense,
  isCarMakeOpen,
  setIsCarMakeOpen,
  isCarColorOpen,
  setIsCarColorOpen,
  makeRef,
}) {
  return (
    <div
      className={
        styles.groupsContainer2
      }
    >
      <button
        type="button"
        className={styles.inputGroupBtn}
        onClick={() =>
          setIsCarMakeOpen(true)
        }
      >
        <FaCar
          style={{
            marginRight: 5,
            position: 'relative',
            top: '5px',
          }}
          size={'19px'}
        />
        Car Make
      </button>
      <input
        ref={makeRef}
        type="text"
        name="make"
        value={make || freqMake || ''}
        id="car_make"
        onChange={(e) => {
          setMake(e.target.value) ||
            setFreqMake(e.target.value);
        }}
        placeholder="Car make"
        className={styles.scanInput}
        // disabled
      />
      <button
        type="button"
        className={styles.inputGroupBtn}
        onClick={() => {
          setIsCarColorOpen(true);
        }}
      >
        <IoIosColorFill
          style={{
            marginRight: 5,
            position: 'relative',
            top: '5px',
          }}
          size={'19px'}
        />
        Car Color
      </button>
      <input
        type="text"
        value={color || ''}
        className={styles.scanInput}
        placeholder="Car color"
        id="color"
        onChange={(e) => {
          setColor();
        }}
      />
      <input
        type="text"
        value={license || ''}
        onChange={(e) =>
          setLicense(e.target.value)
        }
        className={styles.scanInput}
        placeholder="Enter license plate"
        id="license"
      />
    </div>
  );
}
